import { PaymentCompleteComponent } from './components/payment-complete/payment-complete.component';
import { BountyResolver } from './resolvers/bounty.resolver';
import { BountiesResolver } from './resolvers/bounties.resolver';
import { CommentsResolver } from './resolvers/comments.resolver';
import { CommentsComponent } from './components/comments/comments.component';
import { Routes } from '@angular/router';
import { BountiesListComponent } from './components/bounties/bounties-list/bounties-list.component';
import { ViewBountyComponent } from './components/bounties/view-bounty/view-bounty.component';
import { ViewClaimComponent } from './components/view-claim/view-claim.component';
import { UserProfileComponent } from './components/my-bounties-list/user-profile.component';
import { SupportComponent } from './components/support/support.component';
import { StatsComponent } from './components/stats/stats.component';
import { EditBountyComponent } from './components/edit-bounty/edit-bounty.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsResolver } from './resolvers/notifications.resolver';
import { DisabledPlaceholderComponent } from './components/create-bounty/disabled-placeholder/disabled-placeholder.component';
var ɵ0 = BountiesResolver, ɵ1 = NotificationsResolver, ɵ2 = CommentsResolver, ɵ3 = BountyResolver;
var appRoutes = [
    {
        path: '',
        component: BountiesListComponent,
        runGuardsAndResolvers: 'always',
        resolve: { data: ɵ0 },
    },
    { path: 'user/:id', component: UserProfileComponent },
    {
        path: 'notifications',
        component: NotificationsComponent,
        runGuardsAndResolvers: 'always',
        resolve: { data: ɵ1 },
    },
    {
        path: 'comments',
        component: CommentsComponent,
        resolve: { data: ɵ2 },
        runGuardsAndResolvers: 'always',
    },
    { path: 'bounties/create', component: DisabledPlaceholderComponent },
    { path: 'payment-complete-redirect/:id/:success', component: PaymentCompleteComponent },
    { path: 'bounties/:id/edit', component: EditBountyComponent },
    {
        path: 'bounties/:id',
        component: ViewBountyComponent,
        resolve: { data: ɵ3 },
        runGuardsAndResolvers: 'always',
    },
    { path: 'claims/:id', component: ViewClaimComponent },
    { path: 'support', component: SupportComponent },
    { path: 'stats', component: StatsComponent },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
